/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated.settings'
import { Route as AuthenticatedPresentationsRouteImport } from './routes/_authenticated.presentations'
import { Route as AuthenticatedHelpRouteImport } from './routes/_authenticated.help'
import { Route as AuthenticatedFlowsRouteImport } from './routes/_authenticated.flows'
import { Route as AuthenticatedFilesRouteImport } from './routes/_authenticated.files'
import { Route as AuthenticatedExercisesRouteImport } from './routes/_authenticated.exercises'
import { Route as AuthenticatedCoursesRouteImport } from './routes/_authenticated.courses'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as AuthenticatedPresentationsIndexRouteImport } from './routes/_authenticated.presentations.index'
import { Route as AuthenticatedPresentationsIdRouteImport } from './routes/_authenticated.presentations.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPresentationsRoute =
  AuthenticatedPresentationsRouteImport.update({
    id: '/presentations',
    path: '/presentations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHelpRoute = AuthenticatedHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFlowsRoute = AuthenticatedFlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFilesRoute = AuthenticatedFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated.files.lazy').then((d) => d.Route),
)
const AuthenticatedExercisesRoute = AuthenticatedExercisesRouteImport.update({
  id: '/exercises',
  path: '/exercises',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCoursesRoute = AuthenticatedCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPresentationsIndexRoute =
  AuthenticatedPresentationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPresentationsRoute,
  } as any)
const AuthenticatedPresentationsIdRoute =
  AuthenticatedPresentationsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedPresentationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/courses': typeof AuthenticatedCoursesRoute
  '/exercises': typeof AuthenticatedExercisesRoute
  '/files': typeof AuthenticatedFilesRoute
  '/flows': typeof AuthenticatedFlowsRoute
  '/help': typeof AuthenticatedHelpRoute
  '/presentations': typeof AuthenticatedPresentationsRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/presentations/$id': typeof AuthenticatedPresentationsIdRoute
  '/presentations/': typeof AuthenticatedPresentationsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/courses': typeof AuthenticatedCoursesRoute
  '/exercises': typeof AuthenticatedExercisesRoute
  '/files': typeof AuthenticatedFilesRoute
  '/flows': typeof AuthenticatedFlowsRoute
  '/help': typeof AuthenticatedHelpRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/presentations/$id': typeof AuthenticatedPresentationsIdRoute
  '/presentations': typeof AuthenticatedPresentationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/courses': typeof AuthenticatedCoursesRoute
  '/_authenticated/exercises': typeof AuthenticatedExercisesRoute
  '/_authenticated/files': typeof AuthenticatedFilesRoute
  '/_authenticated/flows': typeof AuthenticatedFlowsRoute
  '/_authenticated/help': typeof AuthenticatedHelpRoute
  '/_authenticated/presentations': typeof AuthenticatedPresentationsRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/presentations/$id': typeof AuthenticatedPresentationsIdRoute
  '/_authenticated/presentations/': typeof AuthenticatedPresentationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/courses'
    | '/exercises'
    | '/files'
    | '/flows'
    | '/help'
    | '/presentations'
    | '/settings'
    | '/presentations/$id'
    | '/presentations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admin'
    | '/courses'
    | '/exercises'
    | '/files'
    | '/flows'
    | '/help'
    | '/settings'
    | '/'
    | '/presentations/$id'
    | '/presentations'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/admin'
    | '/_authenticated/courses'
    | '/_authenticated/exercises'
    | '/_authenticated/files'
    | '/_authenticated/flows'
    | '/_authenticated/help'
    | '/_authenticated/presentations'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/presentations/$id'
    | '/_authenticated/presentations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/presentations': {
      id: '/_authenticated/presentations'
      path: '/presentations'
      fullPath: '/presentations'
      preLoaderRoute: typeof AuthenticatedPresentationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/help': {
      id: '/_authenticated/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthenticatedHelpRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flows': {
      id: '/_authenticated/flows'
      path: '/flows'
      fullPath: '/flows'
      preLoaderRoute: typeof AuthenticatedFlowsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files': {
      id: '/_authenticated/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthenticatedFilesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exercises': {
      id: '/_authenticated/exercises'
      path: '/exercises'
      fullPath: '/exercises'
      preLoaderRoute: typeof AuthenticatedExercisesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/courses': {
      id: '/_authenticated/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AuthenticatedCoursesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/presentations/': {
      id: '/_authenticated/presentations/'
      path: '/'
      fullPath: '/presentations/'
      preLoaderRoute: typeof AuthenticatedPresentationsIndexRouteImport
      parentRoute: typeof AuthenticatedPresentationsRoute
    }
    '/_authenticated/presentations/$id': {
      id: '/_authenticated/presentations/$id'
      path: '/$id'
      fullPath: '/presentations/$id'
      preLoaderRoute: typeof AuthenticatedPresentationsIdRouteImport
      parentRoute: typeof AuthenticatedPresentationsRoute
    }
  }
}

interface AuthenticatedPresentationsRouteChildren {
  AuthenticatedPresentationsIdRoute: typeof AuthenticatedPresentationsIdRoute
  AuthenticatedPresentationsIndexRoute: typeof AuthenticatedPresentationsIndexRoute
}

const AuthenticatedPresentationsRouteChildren: AuthenticatedPresentationsRouteChildren =
  {
    AuthenticatedPresentationsIdRoute: AuthenticatedPresentationsIdRoute,
    AuthenticatedPresentationsIndexRoute: AuthenticatedPresentationsIndexRoute,
  }

const AuthenticatedPresentationsRouteWithChildren =
  AuthenticatedPresentationsRoute._addFileChildren(
    AuthenticatedPresentationsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedCoursesRoute: typeof AuthenticatedCoursesRoute
  AuthenticatedExercisesRoute: typeof AuthenticatedExercisesRoute
  AuthenticatedFilesRoute: typeof AuthenticatedFilesRoute
  AuthenticatedFlowsRoute: typeof AuthenticatedFlowsRoute
  AuthenticatedHelpRoute: typeof AuthenticatedHelpRoute
  AuthenticatedPresentationsRoute: typeof AuthenticatedPresentationsRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedCoursesRoute: AuthenticatedCoursesRoute,
  AuthenticatedExercisesRoute: AuthenticatedExercisesRoute,
  AuthenticatedFilesRoute: AuthenticatedFilesRoute,
  AuthenticatedFlowsRoute: AuthenticatedFlowsRoute,
  AuthenticatedHelpRoute: AuthenticatedHelpRoute,
  AuthenticatedPresentationsRoute: AuthenticatedPresentationsRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
